import { useImmer } from "use-immer";
import { useRef, useState, useEffect, useContext } from "react";
import SimpleReactValidator from "simple-react-validator";
import { useDebounce } from "use-debounce";
import { useDelete, usePermission } from "../../../shared";
import { AppContext } from "../../../store";

export const usePOSSyncLists = () => {
  const isUnitCreate = usePermission("unit-create");
  const isUnitEditable = usePermission("unit-modify");
  const isUnitDeletable = usePermission("unit-delete");
  const [, forceUpdate] = useState();
  const validator = useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } }),
  );
  const { deleteInfo, onDelete, resetDeleteInfo } = useDelete();
  const moduleName = "units";
  const { tableData, setSorting, setPagination, setSearchState } =
    useContext(AppContext);
  const { sorting, pagination, search } = tableData[moduleName];
  const [state, setState] = useImmer({
    isLoading: true,
    dataList: {},
    filters: {},
  });

  let fdata = {
    PLU0019: {
      recipes: [
        {
          id: 6,
          name: "White - Round Roll 2.3kg",
          plu: "PLU0019",
          category_id: 4,
          category: "Breads1",
          subcategory_id: 14,
          subcategory: "White Breads",
          status: 1,
          cost_exc_gst: 27.0995,
          set_as_default: 1,
        },
      ],
    },
    PLU0021: {
      recipes: [
        {
          id: 7,
          name: "White - Hamburger Roll 2.5kg",
          plu: "PLU0021",
          category_id: 4,
          category: "Breads1",
          subcategory_id: 14,
          subcategory: "White Breads",
          status: 1,
          cost_exc_gst: 2.4720999999999997,
          set_as_default: 1,
        },
      ],
    },
    PLU0020: {
      recipes: [
        {
          id: 8,
          name: "White - Long Roll 3kg",
          plu: "PLU0020",
          category_id: 4,
          category: "Breads1",
          subcategory_id: 14,
          subcategory: "White Breads",
          status: 1,
          cost_exc_gst: 2.7385,
          set_as_default: 1,
        },
      ],
    },
    PLU0004: {
      recipes: [
        {
          id: 9,
          name: "Wholemeal - Sandwich Loaf 750gm",
          plu: "PLU0004",
          category_id: 4,
          category: "Breads1",
          subcategory_id: 59,
          subcategory: "Procedures",
          status: 1,
          cost_exc_gst: 2.41905,
          set_as_default: 1,
        },

        {
          id: 743,
          name: "Demo data",
          plu: "PLU0004",
          category_id: 73,
          category: "QA1",
          subcategory_id: 74,
          subcategory: "Test",
          status: 0,
          cost_exc_gst: 0,
          set_as_default: 0,
        },
        {
          id: 1058,
          name: "BXGY Fixed 2$  Max 0",
          plu: "PLU0004",
          category_id: 4,
          category: "Breads1",
          subcategory_id: 48,
          subcategory: "Finnen Breads (m'land)",
          status: 0,
          cost_exc_gst: 0,
          set_as_default: 0,
        },
      ],
    },
  };

  useEffect(() => {
    // getUnits();
    setState((draft) => {
      draft.dataList = transformData(fdata);
      draft.isLoading = false;
    });
  }, []);

  const transformData = (apiData) => {
    return Object.entries(apiData).map(([plu, value]) => ({
      plu,
      isCustomRow: true, // parent row
      subRows: value.recipes.map((r) => ({
        ...r,
        plu,
        isCustomRow: false,
      })),
    }));
  };
  return { fdata, state };
};
